export const DEFAULT_MIN_PASSWORD_EVALUATION_LENGTH = 4;

export enum PasswordStrength {
  Low = 'low',
  Medium = 'medium',
  Strong = 'strong',
}
